<template>
    <div class="statistica__quotations">
            <div class="statistica__quotations-title">
                Котировки
            </div>
            <div class="statistica__quotations-wrap">
                <div class="statistica__quotations-column">
                    <div class="statistica__quotations-row">
                        <div class="statistica__quotations-row-data">{{selectedQuotes.EURUSD.name}}</div>
                        <div class="statistica__quotations-row-data"
                            :class = "selectedQuotes.EURUSD.sign < 0 ? 'color-red' : 'color-green'">
                        {{selectedQuotes.EURUSD.bid.toFixed(selectedQuotes.EURUSD.prec)}}</div>
                        <div class="statistica__quotations-row-data">{{parseFloat(((selectedQuotes.EURUSD.ask - selectedQuotes.EURUSD.bid) * Math.pow(10, selectedQuotes.EURUSD.prec)).toFixed(selectedQuotes.EURUSD.prec))}}</div>
                        <div class="statistica__quotations-row-data"
                            :class = "selectedQuotes.EURUSD.sign < 0 ? 'color-red' : 'color-green'">
                        {{selectedQuotes.EURUSD.ask.toFixed(selectedQuotes.EURUSD.prec)}}</div>
                    </div>
                    <div class="statistica__quotations-row">
                        <div class="statistica__quotations-row-data">{{selectedQuotes.GBPUSD.name}}</div>
                        <div class="statistica__quotations-row-data"
                            :class = "selectedQuotes.EURUSD.sign < 0 ? 'color-red' : 'color-green'">
                        {{selectedQuotes.GBPUSD.bid.toFixed(selectedQuotes.GBPUSD.prec)}}</div>
                        <div class="statistica__quotations-row-data">{{parseFloat(((selectedQuotes.GBPUSD.ask - selectedQuotes.GBPUSD.bid) * Math.pow(10, selectedQuotes.EURUSD.prec)).toFixed(selectedQuotes.GBPUSD.prec))}}</div>
                        <div class="statistica__quotations-row-data"
                            :class = "selectedQuotes.GBPUSD.sign < 0 ? 'color-red' : 'color-green'">
                        {{selectedQuotes.GBPUSD.ask.toFixed(selectedQuotes.GBPUSD.prec)}}</div>
                    </div>
                    <div class="statistica__quotations-row">
                        <div class="statistica__quotations-row-data">{{selectedQuotes.NZDUSD.name}}</div>
                        <div class="statistica__quotations-row-data"
                            :class = "selectedQuotes.NZDUSD.sign < 0 ? 'color-red' : 'color-green'">
                        {{selectedQuotes.NZDUSD.bid.toFixed(selectedQuotes.NZDUSD.prec)}}</div>
                        <div class="statistica__quotations-row-data">{{parseFloat(((selectedQuotes.NZDUSD.ask - selectedQuotes.NZDUSD.bid) * Math.pow(10, selectedQuotes.NZDUSD.prec)).toFixed(selectedQuotes.NZDUSD.prec))}}</div>
                        <div class="statistica__quotations-row-data"
                            :class = "selectedQuotes.NZDUSD.sign < 0 ? 'color-red' : 'color-green'">
                        {{selectedQuotes.NZDUSD.ask.toFixed(selectedQuotes.NZDUSD.prec)}}</div>
                    </div>
                </div>
                <div class="statistica__quotations-column">
                    <div class="statistica__quotations-row">
                        <div class="statistica__quotations-row-data">{{selectedQuotes.BTCUSD.name}}</div>
                        <div class="statistica__quotations-row-data"
                            :class = "selectedQuotes.BTCUSD.sign < 0 ? 'color-red' : 'color-green'">
                        {{selectedQuotes.BTCUSD.bid.toFixed(selectedQuotes.BTCUSD.prec)}}</div>
                        <div class="statistica__quotations-row-data">{{parseFloat(((selectedQuotes.BTCUSD.ask - selectedQuotes.BTCUSD.bid) * Math.pow(10, selectedQuotes.BTCUSD.prec)).toFixed(selectedQuotes.BTCUSD.prec))}}</div>
                        <div class="statistica__quotations-row-data"
                            :class = "selectedQuotes.BTCUSD.sign < 0 ? 'color-red' : 'color-green'">
                        {{selectedQuotes.BTCUSD.ask.toFixed(selectedQuotes.BTCUSD.prec)}}</div>
                    </div>
                    <div class="statistica__quotations-row">
                        <div class="statistica__quotations-row-data">{{selectedQuotes.AUDUSD.name}}</div>
                        <div class="statistica__quotations-row-data"
                            :class = "selectedQuotes.AUDUSD.sign < 0 ? 'color-red' : 'color-green'">
                        {{selectedQuotes.AUDUSD.bid.toFixed(selectedQuotes.AUDUSD.prec)}}</div>
                        <div class="statistica__quotations-row-data">{{parseFloat(((selectedQuotes.AUDUSD.ask - selectedQuotes.AUDUSD.bid) * Math.pow(10, selectedQuotes.AUDUSD.prec)).toFixed(selectedQuotes.AUDUSD.prec))}}</div>
                        <div class="statistica__quotations-row-data"
                            :class = "selectedQuotes.AUDUSD.sign < 0 ? 'color-red' : 'color-green'">
                        {{selectedQuotes.AUDUSD.ask.toFixed(selectedQuotes.AUDUSD.prec)}}</div>
                    </div>
                    <div class="statistica__quotations-row">
                        <div class="statistica__quotations-row-data">{{selectedQuotes.ETHUSD.name}}</div>
                        <div class="statistica__quotations-row-data"
                            :class = "selectedQuotes.ETHUSD.sign < 0 ? 'color-red' : 'color-green'">
                        {{selectedQuotes.ETHUSD.bid.toFixed(selectedQuotes.ETHUSD.prec)}}</div>
                        <div class="statistica__quotations-row-data">{{parseFloat(((selectedQuotes.ETHUSD.ask - selectedQuotes.ETHUSD.bid) * Math.pow(10, selectedQuotes.ETHUSD.prec)).toFixed(selectedQuotes.ETHUSD.prec))}}</div>
                        <div class="statistica__quotations-row-data"
                            :class = "selectedQuotes.ETHUSD.sign < 0 ? 'color-red' : 'color-green'">
                        {{selectedQuotes.ETHUSD.ask.toFixed(selectedQuotes.ETHUSD.prec)}}</div>
                    </div>
                </div>
                <div class="statistica__quotations-column">
                    <div class="statistica__quotations-row">
                        <div class="statistica__quotations-row-data"></div>
                        <div class="statistica__quotations-row-data color-red"></div>
                        <div class="statistica__quotations-row-data color-yellow"></div>
                        <div class="statistica__quotations-row-data color-green"></div>
                    </div>
                    <div class="statistica__quotations-row">
                        <div class="statistica__quotations-row-data"></div>
                        <div class="statistica__quotations-row-data color-red"></div>
                        <div class="statistica__quotations-row-data color-yellow"></div>
                        <div class="statistica__quotations-row-data color-green"></div>
                    </div>
                    <div class="statistica__quotations-row">
                        <div class="statistica__quotations-row-data"></div>
                        <div class="statistica__quotations-row-data color-red"></div>
                        <div class="statistica__quotations-row-data color-yellow"></div>
                        <div class="statistica__quotations-row-data color-green"></div>
                    </div>
                </div>
            </div>
           </div>
</template>
<script>
import { mapGetters, mapMutations } from "vuex";
import Vue from "vue";
import { settingsStore } from "../../model/settings-store.js";
export default {
    data() {
    return {
      settings: {}
    };
  },
  computed: {
    ...mapGetters({
      quotes: "quotes/getQuotes",
      filteredQuotes: "quotes/getFilteredQuotes"  
    }),
    selectedQuotes() {
      if (!this.settings || !this.settings.selected) return {};
      return this.filteredQuotes(this.settings.selected);
    }
  },
  created() {
    let defaultSets = {
      selected: {
        EURUSD: true,
        GBPUSD: true,
        BTCUSD: true,
        ETHUSD: true,
        NZDUSD: true,
        AUDUSD: true
      }
    };
    Vue.set(this.$data, "settings", defaultSets);
  }
}
</script>
<style lang="less" scoped>
.statistica__quotations
    {
        width: 912px;
        background-color: #324258;
        display: block;
        color: #fff;
        border-radius: 4px;
        margin-top: 0px;
        margin-bottom: 40px;
        
        &-title
        {
            font-family: Montserrat;
            font-size: 16px;
            font-weight: bold;
            font-style: normal;
            font-stretch: normal;
            line-height: 3;
            letter-spacing: 0.4px;
            text-transform: uppercase;
            padding: 0 12px;
        }
        
        &-wrap
        {
            display: flex;
        }
        
        &-column
        {
            border-right: 1px solid #293546;
        }
        
        &-row
        {
            display: flex;
            border-top:1px solid #293546;
            min-height: 27px;
            
            &-data
            {
                font-family: Arimo;
                font-size: 13px;
                font-weight: bold;
                font-style: normal;
                font-stretch: normal;
                line-height: 2.15;
                letter-spacing: 0.4px;
                text-transform: uppercase;
                color: #ffffff;
                
                &:nth-child(1)
                {
                    width: 100px;
                    box-sizing: border-box;
                    padding-left: 12px;
                }
                
                &:nth-child(2)
                {
                    width: 76px;
                    box-sizing: border-box;
                    text-align: right;
                    padding-right: 12px;
                }
                
                &:nth-child(3)
                {
                    width: 52px;
                    box-sizing: border-box;
                    text-align: center;
                }
                
                &:nth-child(4)
                {
                    width: 76px;
                    box-sizing: border-box;
                    text-align: right;
                    padding-right: 12px;
                }
            }
        }
    }
    
</style>
